import animationData from '@/lottie/AILoading.json'

import { createLottieAnimation } from '../Lottie'

const AiLoading = createLottieAnimation(animationData)
AiLoading.displayName = 'AiLoading'

export { AiLoading }
